import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-376c7d64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content editing" }
const _hoisted_2 = {
  key: 0,
  class: "steps"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "active"
}
const _hoisted_5 = {
  key: 1,
  class: "complete"
}
const _hoisted_6 = {
  key: 2,
  class: ""
}
const _hoisted_7 = {
  key: 1,
  class: "mobile-bottom-nav",
  style: {"flex-direction":"column","gap":"20px"}
}
const _hoisted_8 = {
  key: 0,
  style: {"margin-top":"30px","margin-bottom":"10px"}
}
const _hoisted_9 = { style: {"margin-bottom":"20px"} }
const _hoisted_10 = { class: "p-float-label terms-and-conditions" }
const _hoisted_11 = {
  class: "pointerevents no-tooltip",
  for: "termsandconditions"
}
const _hoisted_12 = {
  href: "/datenschutz",
  target: "_blank"
}
const _hoisted_13 = { style: {"padding-left":"30px"} }
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = {
  key: 0,
  class: "mobile-hide sidebar-image"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "mobile-hide sidebar-image"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 2,
  class: "mobile-hide sidebar-image"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "testimonials"
}
const _hoisted_22 = { class: "mobile-hide headline" }

import Wizard from '../components/Wizard.vue'
    import DirectSignUpWelcome from './DirectSignUpWelcome.vue'
    import CandidateProfileForm from '../components/CandidateProfileForm.vue'
    import JobPreferences from '../components/profile/JobPreferences.vue'
    import ExpertiseAndSkill from '../components/profile/ExpertiseAndSkill.vue'
    import EmployerPreferences from '../components/profile/EmployerPreferences.vue'
    import Documents from '../components/profile/Documents.vue'
    import Salary from '@/registration/tech/wizard/Salary.vue';
    import { ArrowRightIcon } from '@heroicons/vue/solid';
    import { createCandidateService } from '@/services/candidateService';
    import { createProfileService } from "@/services/profileService";
    import { createSignupService } from "@/services/signupService";
    import { ProfileSuggestions } from "@/models/ProfileSuggestions";
    import { createAuthenticationService } from '@/services/authenticationService';
    import { CandidateProfile } from "@/models/CandidateProfile";
    import { EncCandidateProfile } from "@/models/EncCandidateProfile";
    import { WizardProgress } from "@/models/WizardProgress";
    import { getCurrentInstance, onMounted, ref } from 'vue';
    import { useRoute, useRouter } from "vue-router";
    import TestimonialCard from "@/components/TestimonialCard.vue";
    import { createLandingPageContentService } from "@/services/landingPageContentService";
    import { useI18n } from 'vue-i18n'
    import { useToast } from "primevue/usetoast";
    import { convertSalutationForDatabase } from "@/helper";
    import { useLocalStorageStore } from '@/stores/localStorage'
    import { storeToRefs } from 'pinia'
    import StepOne from "@/registration/tech/wizard/StepOne.vue";
    import StepTwo from "@/registration/tech/wizard/StepTwo.vue";
    import StepThree from "@/registration/tech/wizard/StepThree.vue";
    import { WillingnessToChange } from "@/models/WillingnessToChange";
    import { BrandId } from "@/models/BrandIds";
    import Header from "@/components/Header.vue";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationPopUp',
  emits: ['submitted', "load-dashboard", "login"],
  setup(__props, { expose: __expose, emit: __emit }) {

    const localStorageStore = useLocalStorageStore();
    const { getScopeKeyFromNumber, isTechScope } = storeToRefs(localStorageStore);
    const emit = __emit;
    const route = useRoute();
    const randomCustomer1 = ref([]);
    const randomCustomer2 = ref([]);
    const { t } = useI18n();
    const step = ref<number | null>(0);
    const hideTermsOfConditionsCheckBoxBecauseOfResuming = ref(false);
    const display = ref(false);
    const showSpinner = ref(false);
    const app = getCurrentInstance();
    const router = useRouter();
    const acceptTermsAndConditions = ref(false);
    const suggestions = ref<ProfileSuggestions>();

    const registrationData = ref<CandidateProfile | EncCandidateProfile>([]);
    const wizardProgress = ref<WizardProgress>({
        candidateEmail: null,
        progressStep: 0,
        candidateId: null,
        encryptedCandidateId: null
    });
    const wizardStyle = ref("reg-dialog");
    const isDirectSignUp = ref(false);

    onMounted(async () => {
        const service = await createLandingPageContentService();
        const customerReferences = (
            await service.GetCandidateReferencesFinance() // <-- Fixme: finance only?
        ).data;

        const crypto = window.crypto;
        let array = new Uint32Array(2);
        let randomUint32Values = crypto.getRandomValues(array); // Compliant for security-sensitive use cases

        console.log(randomUint32Values)
        let idx = Math.floor(randomUint32Values[0] / (10 ** Number(randomUint32Values[0].toString().length)) * customerReferences.length);

        randomCustomer1.value = customerReferences[idx];
        customerReferences.splice(idx, 1);
        idx = Math.floor(randomUint32Values[1] / (10 ** Number(randomUint32Values[1].toString().length)) * customerReferences.length);
        randomCustomer2.value = customerReferences[idx];

    });

    const close = async function () {        
        if  (isDirectSignUp.value)
            await router.push({ name: 'Home' });
        display.value = false;
    }

    const show = async function (candidate) {       
        showSpinner.value = true;
        if (candidate) {
            registrationData.value = { ...registrationData.value, ...candidate };
            if (registrationData.value.brandId) {
                const scopeKey = getScopeKeyFromNumber.value(registrationData.value.brandId)
                if (scopeKey !== null) localStorageStore.setScope(scopeKey);
            }

            isDirectSignUp.value = true;
            const candidateService = await createSignupService();
            step.value = await candidateService.getWizardStep(candidate.encryptedId);
            hideTermsOfConditionsCheckBoxBecauseOfResuming.value = step.value > 0
        } else {
            await loadCandidate();
            const candidateService = await createCandidateService(app);
            step.value = await candidateService.getWizardStep()
        }

        if (step.value === null) {
            if (isDirectSignUp.value)
                step.value = 0;
            else
                step.value = 1;
        }

        initRegistrationData();
        if (isTechScope.value)
            registrationData.value.brandId = BrandId.ElliotBrowne;
        else
            registrationData.value.brandId = BrandId.BigFour;
        setWizardStyle();
        display.value = true;
        await loadSuggestions();
        showSpinner.value = false;
    }

    const loadSuggestions = async () => {
        const service = await createProfileService(app);
        const result = await service.getSuggestions();
        if (result != null) {
            suggestions.value = result;
        }
    }

    const setWizardStyle = () => {
        wizardStyle.value = "reg-dialog";

        if (isDirectSignUp.value)
            wizardStyle.value += " direct";

        if (isTechScope.value)
            wizardStyle.value += " tech";
        else
            wizardStyle.value += " finance";

        if (isTechScope.value && step.value && step.value >= 1)
            wizardStyle.value += " wide";
    }

    const submitted = ref(false);
    const next = async (data) => {
        
        submitted.value = true;
        if (step.value == 0 && !acceptTermsAndConditions.value && !isDirectSignUp.value)
            return;
        registrationData.value.salutation = convertSalutationForDatabase(registrationData.value.salutation);
        const candidateOrSignupService = isDirectSignUp.value ? await createSignupService() : await createCandidateService(app);
        if (!isDirectSignUp.value) {
            wizardProgress.value.candidateId = registrationData.value.id;
            if (!wizardProgress.value.candidateEmail) {
                const authenticationService = await createAuthenticationService(app);
                const authUserEmail = await authenticationService.getUserEmail();
                if (!authUserEmail) {
                    console.warn("could not find email for non-direct signup user", registrationData)
                } else {
                    wizardProgress.value.candidateEmail = authUserEmail;
                }
            }
        } else {
            wizardProgress.value.encryptedCandidateId = registrationData.value.encryptedId;
        }

        wizardProgress.value.progressStep = step.value;
        await candidateOrSignupService.setProgressStep(wizardProgress.value);

        if (!isDirectSignUp.value && !registrationData.value.id) {
            const candidateId = await candidateOrSignupService.getId();
            if (!candidateId) {
                console.warn("could not retrieve candidate id for non-direct signup", registrationData)
            } else {
                registrationData.value.id = candidateId;
            }
        }

        registrationData.value = { ...registrationData.value, ...data };
        await candidateOrSignupService.updateCandidate(registrationData.value);
        if (!isDirectSignUp.value) {
            if (!registrationData.value.id) {
                registrationData.value.id = await candidateOrSignupService.getId();
            }
        }        
        if (step.value != null && step.value < 5) {
            step.value += 1;
        }
        document.querySelector(".p-dialog .box").scrollTo(0, 0)
        setWizardStyle();
    }

    const prev = (data) => {
        registrationData.value = { ...registrationData.value, ...data };
        if (step.value && step.value > 0) {
            step.value -= 1;
        }

        if (step.value == 0)
            hideTermsOfConditionsCheckBoxBecauseOfResuming.value = true;

        document.querySelector(".p-dialog .box").scrollTo(0, 0)
        setWizardStyle();
    };

    const submitShort = async (data) => {
        if (isDirectSignUp.value) {
            step.value = 5;
            setWizardStyle();
        } else {
            setWizardStyle();
            registrationData.value = { ...registrationData.value, ...data };

            if (!registrationData.value) {
                return;
            }
            registrationData.value.willingnessToChange = WillingnessToChange.VeryHigh;
            await submit(registrationData.value)
        }
    }

    const submit = async (data) => {
        next(data)
        setWizardStyle();
        showSpinner.value = true;
        registrationData.value = { ...registrationData.value, ...data };
        if (!registrationData.value) {
            return;
        }
        const candidateOrSignupService = isDirectSignUp.value ? await createSignupService() : await createCandidateService(app);
        if (!isDirectSignUp.value) {
            const authenticationService = await createAuthenticationService(app);

            const userEmail = await authenticationService.getUserEmail();

            if (!userEmail && !registrationData.value.id)
                return;

            if (!registrationData.value.emailAddress && userEmail)
                registrationData.value.emailAddress = userEmail;

            if (!registrationData.value.emailAddress) {
                const email = await candidateOrSignupService.getEmail();
                if (email)
                    registrationData.value.emailAddress = email;
            }
        }
        if (registrationData.value.fullTime != undefined) {
            if (registrationData.value.fullTime !== true) {
                registrationData.value.fullTime = registrationData.value.fullTime.innerValue;
            }
        }

        if (route.query.source) {
            registrationData.value.sourceParam = route.query.source;
        } else {
            registrationData.value.sourceParam = "organic";
        }

        if (!isDirectSignUp.value) {
            const inserted = await candidateOrSignupService.register(registrationData.value);
            if (inserted) {
                display.value = false;
            } else {
                alert("Failed to insert candidate");
            }
        }

        showSpinner.value = false;

        emit("submitted", registrationData.value);
        display.value = false;
    };

    const loadCandidate = async function () {        
        const candidateService = await createCandidateService(app);
        const existingCandidate = await candidateService.getRegCandidate();        
        if (existingCandidate != null) {
            registrationData.value = { ...registrationData.value, ...existingCandidate };
            if (registrationData.value.brandId) {
                const scopeKey = getScopeKeyFromNumber.value(registrationData.value.brandId)
                if (scopeKey !== null) localStorageStore.setScope(scopeKey);
            }            
        } else {
            const authenticationService = await createAuthenticationService(app);
            const email = await authenticationService.getUserEmail();
            if (!email) {
                console.warn("no email for authenticated user", registrationData)
            } else {
                registrationData.value.emailAddress = email;
            }
        }
    }

    const initRegistrationData = () => {
        if (!registrationData.value.areasOfExpertise)
            registrationData.value.areasOfExpertise = [];

        if (!registrationData.value.skills)
            registrationData.value.skills = [];

        if (!registrationData.value.jobTitles)
            registrationData.value.jobTitles = [];

        if (!registrationData.value.additionalCities)
            registrationData.value.additionalCities = [];

        if (!registrationData.value.reachableFederalStates)
            registrationData.value.reachableFederalStates = [];

        if (!registrationData.value.desiredCompanySizes)
            registrationData.value.desiredCompanySizes = [];

        if (!registrationData.value.desiredClientSizes)
            registrationData.value.desiredClientSizes = [];

        if (!registrationData.value.excludedCompanies)
            registrationData.value.excludedCompanies = [];

        if (!registrationData.value.fullTime && !registrationData.value.qCallSubmitted)
            registrationData.value.fullTime = true;
    }

    const toaster = useToast();

    const cvUploaded = async () => {
        if (isDirectSignUp.value && registrationData.value.brandId === BrandId.BigFour && step.value === 0) {
            await next(registrationData.value);
            return;
        }

        const service = !isDirectSignUp.value ? await createProfileService(app) : await createSignupService();
        const req = !isDirectSignUp.value ? await service.getLatestCV() : service.getLatestCV(registrationData.value.encryptedId);
        if (req) {
            registrationData.value.latestCV = req;
        } else {
            toaster.add({
                severity: "error",
                summary: "Es gab ein Problem beim Aktualisieren der Ansicht",
                detail: "",
                life: 3000,
            });
        }

    }

    __expose({
        show
    });

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createBlock(Wizard, {
    visible: display.value,
    class: _normalizeClass(wizardStyle.value),
    onClose: close,
    showClose: false
  }, {
    "above-box": _withCtx(() => [
      _createVNode(Header)
    ]),
    "sidebar-content": _withCtx(() => [
      (step.value===0 && !_unref(isTechScope))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("img", { src: '/kandidaten/img/Step 0.png' }, null, 8, _hoisted_16)
          ]))
        : _createCommentVNode("", true),
      (_unref(isTechScope))
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("img", { src: '/kandidaten/img/Step 0-tech.png' }, null, 8, _hoisted_18)
          ]))
        : _createCommentVNode("", true),
      (step.value>=1 && step.value<=5 && !_unref(isTechScope))
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("img", {
              src: '/kandidaten/img/Step ' + step.value +'.png'
            }, null, 8, _hoisted_20),
            (step.value===3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(TestimonialCard, {
                    name: randomCustomer1.value.name,
                    job: randomCustomer1.value.job,
                    text: randomCustomer1.value.abstract,
                    img: randomCustomer1.value.img
                  }, null, 8, ["name", "job", "text", "img"]),
                  _createVNode(TestimonialCard, {
                    name: randomCustomer2.value.name,
                    job: randomCustomer2.value.job,
                    text: randomCustomer2.value.abstract,
                    img: randomCustomer2.value.img
                  }, null, 8, ["name", "job", "text", "img"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)("registration.popup.headline7")), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (step.value > 0 && step.value <= 5 && !_unref(isTechScope))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("ul", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createElementVNode("li", { key: i }, [
                    (i === step.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                      : _createCommentVNode("", true),
                    (i < step.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                      : _createCommentVNode("", true),
                    (i > step.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                      : _createCommentVNode("", true)
                  ])
                }), 64))
              ])
            ]))
          : _createCommentVNode("", true),
        (step.value===0 && isDirectSignUp.value && !showSpinner.value && !_unref(isTechScope))
          ? (_openBlock(), _createBlock(DirectSignUpWelcome, {
              key: 1,
              modelValue: registrationData.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((registrationData).value = $event)),
              onNext: next
            }, {
              default: _withCtx(() => [
                (_unref(isTechScope))
                  ? (_openBlock(), _createBlock(Documents, {
                      key: 0,
                      candidate: registrationData.value,
                      showButtons: false,
                      disableValidation: false,
                      currentBrandId: registrationData.value.brandId,
                      isDirectSignUp: true,
                      brandId: 1,
                      onSubmit: submit,
                      onNext: next,
                      onPrevious: prev,
                      onCvUploaded: cvUploaded
                    }, null, 8, ["candidate", "currentBrandId"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (!hideTermsOfConditionsCheckBoxBecauseOfResuming.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("span", _hoisted_10, [
                                _createVNode(_component_Checkbox, {
                                  id: "termsandconditions",
                                  "data-cy": "termsAndConditionsCheckbox",
                                  modelValue: acceptTermsAndConditions.value,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((acceptTermsAndConditions).value = $event)),
                                  binary: true
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("label", _hoisted_11, [
                                  _createTextVNode(_toDisplayString(_unref(t)("registration.data.policy.label1")) + " ", 1),
                                  _createElementVNode("a", _hoisted_12, _toDisplayString(_unref(t)("privacy.policy")), 1),
                                  _createTextVNode(_toDisplayString(_unref(t)("registration.data.policy.label2")), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              (submitted.value && !acceptTermsAndConditions.value)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_unref(t)("registration.data.policy.please.accept")), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createVNode(_component_Button, {
                          "data-cy": "button-profile-next",
                          style: {"width":"100%"},
                          class: "button-primary button-next big",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (next())),
                          disabled: !acceptTermsAndConditions.value && !hideTermsOfConditionsCheckBoxBecauseOfResuming.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("direct.sign.up.start.directly")) + " ", 1),
                            _createVNode(_unref(ArrowRightIcon))
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ]))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (step.value===1 && !_unref(isTechScope))
          ? (_openBlock(), _createBlock(CandidateProfileForm, {
              key: 2,
              modelValue: registrationData.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((registrationData).value = $event)),
              showButtons: true,
              isDirectSignUp: isDirectSignUp.value,
              onNext: next,
              onPrevious: prev,
              onSubmit: submitShort
            }, null, 8, ["modelValue", "isDirectSignUp"]))
          : _createCommentVNode("", true),
        (((step.value===1 && !isDirectSignUp.value) || (step.value===0 && isDirectSignUp.value))  && _unref(isTechScope))
          ? (_openBlock(), _createBlock(StepOne, {
              key: 3,
              candidate: registrationData.value,
              isDirectSignUp: isDirectSignUp.value,
              step: step.value,
              hideTermsOfCondition: hideTermsOfConditionsCheckBoxBecauseOfResuming.value,
              onNext: next
            }, null, 8, ["candidate", "isDirectSignUp", "step", "hideTermsOfCondition"]))
          : _createCommentVNode("", true),
        (((step.value===2 && !isDirectSignUp.value) || (step.value===1 && isDirectSignUp.value))  && _unref(isTechScope))
          ? (_openBlock(), _createBlock(StepTwo, {
              key: 4,
              candidate: registrationData.value,
              isDirectSignUp: isDirectSignUp.value,
              step: step.value,
              onPrevious: prev,
              onNext: next
            }, null, 8, ["candidate", "isDirectSignUp", "step"]))
          : _createCommentVNode("", true),
        (((step.value===3 && !isDirectSignUp.value) || (step.value===2 && isDirectSignUp.value))  && _unref(isTechScope))
          ? (_openBlock(), _createBlock(StepThree, {
              key: 5,
              candidate: registrationData.value,
              isDirectSignUp: isDirectSignUp.value,
              step: step.value,
              onPrevious: prev,
              onSubmit: submit
            }, null, 8, ["candidate", "isDirectSignUp", "step"]))
          : _createCommentVNode("", true),
        (step.value===2 && suggestions.value && !_unref(isTechScope))
          ? (_openBlock(), _createBlock(ExpertiseAndSkill, {
              key: 6,
              candidate: registrationData.value,
              showButtons: true,
              availableSkills: suggestions.value.skills,
              availableExpertises: suggestions.value.areasOfExpertise,
              availableJobTitles: suggestions.value.jobTitles,
              onNext: next,
              onPrevious: prev
            }, null, 8, ["candidate", "availableSkills", "availableExpertises", "availableJobTitles"]))
          : _createCommentVNode("", true),
        (step.value===3 && !_unref(isTechScope) && suggestions.value)
          ? (_openBlock(), _createBlock(JobPreferences, {
              key: 7,
              candidate: registrationData.value,
              showButtons: true,
              knownCities: suggestions.value.cities,
              federalStates: suggestions.value.federalStates,
              disableValidation: !registrationData.value.qCallSubmitted,
              onNext: next,
              onPrevious: prev
            }, null, 8, ["candidate", "knownCities", "federalStates", "disableValidation"]))
          : _createCommentVNode("", true),
        (step.value===4 && !_unref(isTechScope) && suggestions.value)
          ? (_openBlock(), _createBlock(EmployerPreferences, {
              key: 8,
              candidate: registrationData.value,
              showButtons: true,
              "is-viewing": false,
              availableCompanySizes: suggestions.value.companySizes,
              availableClientSizes: suggestions.value.clientSizes,
              knownCompanies: suggestions.value?.knownCompanies,
              onNext: next,
              onPrevious: prev
            }, null, 8, ["candidate", "availableCompanySizes", "availableClientSizes", "knownCompanies"]))
          : _createCommentVNode("", true),
        (step.value===5 && !_unref(isTechScope) && !showSpinner.value)
          ? (_openBlock(), _createBlock(Salary, {
              key: 9,
              candidate: registrationData.value
            }, null, 8, ["candidate"]))
          : _createCommentVNode("", true),
        (step.value===5 && !_unref(isTechScope) && !showSpinner.value)
          ? (_openBlock(), _createBlock(Documents, {
              key: 10,
              candidate: registrationData.value,
              showButtons: !_unref(isTechScope),
              disableValidation: true,
              isDirectSignUp: isDirectSignUp.value,
              currentBrandId: registrationData.value.brandId,
              hideConsent: true,
              "is-viewing": false,
              onSubmit: submit,
              onNext: next,
              onPrevious: prev,
              onCvUploaded: cvUploaded
            }, null, 8, ["candidate", "showButtons", "isDirectSignUp", "currentBrandId"]))
          : _createCommentVNode("", true),
        (showSpinner.value && step.value > 0)
          ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 11 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "class"]))
}
}

})